import styled from 'styled-components';
import { Form, InputNumber, Tooltip } from 'antd';

const WHITE_COLOR = '#fff';
const RED_COLOR = '#ff4d4f';
const GRAY_COLOR = '#e6e6e6';

export const InputNumberWrapper = styled(InputNumber)`
	font-size: 1rem;
	height: 2.6rem;
	padding-top: 3px;
	padding-bottom: 0;
	bottom: 4.5px;

	&.ant-input-number,
	.ant-input-number {
		border-radius: 0 8px 8px 0 !important;
		border: 2px solid ${GRAY_COLOR} !important;
		background: ${WHITE_COLOR} !important;
	}

	.ant-input-number-group-addon {
		height: 2.5rem;
		padding: 0 1rem;
		border-radius: 8px 0 0 8px !important;
		border: 2px solid ${GRAY_COLOR} !important;
		border-right: none !important;
		background: ${WHITE_COLOR} !important;
		box-sizing: border-box;
		font-weight: bold;
		font-size: 1.1rem;
		bottom: 4.5px;
	}
`;

export const CustomTooltip = styled(Tooltip)`
	font-size: 0.7rem;
	margin-left: 0.5rem;
	vertical-align: middle;
	margin-left: 6px;
`;

export const RequiredAsterisk = styled.div`
	margin-left: 1px;
	color: ${RED_COLOR};
`;

export const RequiredFormItem = styled(Form.Item)`
	margin: 0;

	.ant-form-item-label {
		display: flex;
		justify-content: flex-start;
	}

	label {
		font-size: 1.1rem;
	}

	.custom-label-span {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.ant-form-item-required {
		display: flex;
		justify-content: flex-start;
		flex-direction: row-reverse;
		font-weight: 600;
		font-size: 1.1rem;
	}

	.ant-form-item-required::before {
		margin-left: 0.4rem;
		color: ${RED_COLOR} !important;
	}

	.ant-form-item-explain-error {
		position: absolute;
	}

	@media (max-width: 1240px) {
		.ant-form-item-label > label {
			font-size: 1rem !important;
			line-height: 0.9rem !important;
		}
		.custom-label-span {
			font-size: 1rem !important;
			line-height: 0.9rem !important;
		}
	}
`;
export const LabelSpan = styled.span`
	gap: 2px;
	font-weight: 600;
	font-size: 1.1rem;
	align-items: center;
	display: inline-flex;

	@media (max-width: 576px) {
		font-size: 0.9rem;
	}

	@media (max-width: 1240px) {
		font-size: 1rem !important;
		line-height: 0.9rem !important;
	}
`;
